<template>
  <div class="tabs-nav tw-border-b tw-border-gray-200">
    <div
      class="responsive-nav tw-flex tw-justify-between tw-items-center tw-px-4 tw-pt-4 tw-pb-4"
    >
      <div class="tw-flex tw-space-x-4">
        <button
          v-for="tab in tabs"
          :key="tab.id"
          @click="handleTabClick(tab.id)"
          class="tw-px-8 tw-py-2 tw-text-base tw-font-medium hover:tw-bg-transparent hover:tw-text-gray-700"
          :class="[
            activeTab === tab.id
              ? 'tw-text-black tw-border-b-4 tw-border-primary'
              : 'tw-text-gray-500',
          ]"
        >
          {{ tab.label }}
        </button>
      </div>

      <div>
        <slot name="action-button"></slot>
      </div>
    </div>
  </div>
</template>
  
  <script setup>
import { defineProps, defineEmits } from "vue";

const props = defineProps({
  tabs: {
    type: Array,
    required: true,
  },
  activeTab: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(["tab-change"]);

const handleTabClick = (tabId) => {
  if (tabId !== props.activeTab) {
    emit("tab-change", tabId);
  }
};
</script>

  <style lang="scss" scoped>
.responsive-nav {
  @media only screen and (max-width: 800px) {
    flex-direction: column;
    gap: 20px;
    align-items: self-start;
  }
}
</style>